import { CategoriesData, CategoryPathUrls } from '~/bootcamp/types/bootcamp.types'

import { CATEGORY_COLORS, CATEGORY_PATHS } from '~/bootcamp/constants/bootcamp.const'
import { VideoTopic } from '~/types/bootcamp'
import { AppLanguage } from '~/types/locale'

function getTopicList(
  categoriesData: CategoriesData | null,
  enCategoriesData: CategoriesData | null,
  locale: AppLanguage,
): VideoTopic[] {
  if (!categoriesData) return []

  const bootcampCategories = [
    {
      title: '',
      titleTransKey: 'algebra' as const,
      path: getPath(locale, categoriesData, enCategoriesData, CATEGORY_PATHS.algebra),
      categoryThemeColor: CATEGORY_COLORS['algebra'].bgClass,
      categoryFontColor: CATEGORY_COLORS['algebra'].textClass,
      noOfSubjects: categoriesData['algebra'].length,
      isPublished: categoriesData['algebra'].length > 0,
      noOfCompletedSubjects: 0,
      noOfChestsInGyms: getNoOfChestsInGyms(categoriesData['algebra']),
      noOfVideos: getNoOfVideosInGyms(categoriesData['algebra']),
      noOfActivities: getNoOfActivitiesInGyms(categoriesData['algebra']),
      noOfVideosEn: enCategoriesData ? getNoOfVideosInGyms(enCategoriesData['algebra']) : 0,
      noOfActivitiesEn: enCategoriesData ? getNoOfActivitiesInGyms(enCategoriesData['algebra']) : 0,
      noOfWatchedVideos: 0,
      isUpcoming: getIsUpcoming(locale, enCategoriesData, CATEGORY_PATHS.algebra),
      key: CATEGORY_PATHS.algebra,
    },
    {
      title: '',
      titleTransKey: 'geometry' as const,
      path: getPath(locale, categoriesData, enCategoriesData, CATEGORY_PATHS.geometry),
      categoryThemeColor: CATEGORY_COLORS['geometry'].bgClass,
      categoryFontColor: CATEGORY_COLORS['geometry'].textClass,
      noOfSubjects: categoriesData['geometry'].length,
      isPublished: categoriesData['geometry'].length > 0,
      noOfCompletedSubjects: 0,
      noOfChestsInGyms: getNoOfChestsInGyms(categoriesData['geometry']),
      noOfVideos: getNoOfVideosInGyms(categoriesData['geometry']),
      noOfActivities: getNoOfActivitiesInGyms(categoriesData['geometry']),
      noOfVideosEn: enCategoriesData ? getNoOfVideosInGyms(enCategoriesData['geometry']) : 0,
      noOfActivitiesEn: enCategoriesData ? getNoOfActivitiesInGyms(enCategoriesData['geometry']) : 0,
      noOfWatchedVideos: 0,
      isUpcoming: getIsUpcoming(locale, enCategoriesData, CATEGORY_PATHS.geometry),
      key: CATEGORY_PATHS.geometry,
    },
    {
      title: '',
      titleTransKey: 'numbersAndQuantities' as const,
      path: getPath(locale, categoriesData, enCategoriesData, CATEGORY_PATHS.numbersAndQuantities),
      categoryThemeColor: CATEGORY_COLORS['numbers-and-quantities'].bgClass,
      categoryFontColor: CATEGORY_COLORS['numbers-and-quantities'].textClass,
      noOfSubjects: categoriesData['numbers-and-quantities'].length,
      isPublished: categoriesData['numbers-and-quantities'].length > 0,
      noOfCompletedSubjects: 0,
      noOfChestsInGyms: getNoOfChestsInGyms(categoriesData['numbers-and-quantities']),
      noOfVideos: getNoOfVideosInGyms(categoriesData['numbers-and-quantities']),
      noOfActivities: getNoOfActivitiesInGyms(categoriesData['numbers-and-quantities']),
      noOfVideosEn: enCategoriesData ? getNoOfVideosInGyms(enCategoriesData['numbers-and-quantities']) : 0,
      noOfActivitiesEn: enCategoriesData ? getNoOfActivitiesInGyms(enCategoriesData['numbers-and-quantities']) : 0,
      noOfWatchedVideos: 0,
      isUpcoming: getIsUpcoming(locale, enCategoriesData, CATEGORY_PATHS.numbersAndQuantities),
      key: CATEGORY_PATHS.numbersAndQuantities,
    },
    {
      title: '',
      titleTransKey: 'statisticsAndProbability' as const,
      path: getPath(locale, categoriesData, enCategoriesData, CATEGORY_PATHS.statisticsAndProbability),
      categoryThemeColor: CATEGORY_COLORS['statistics-and-probability'].bgClass,
      categoryFontColor: CATEGORY_COLORS['statistics-and-probability'].textClass,
      noOfSubjects: categoriesData['statistics-and-probability'].length,
      isPublished: categoriesData['statistics-and-probability'].length > 0,
      noOfCompletedSubjects: 0,
      noOfChestsInGyms: getNoOfChestsInGyms(categoriesData['statistics-and-probability']),
      noOfVideos: getNoOfVideosInGyms(categoriesData['statistics-and-probability']),
      noOfActivities: getNoOfActivitiesInGyms(categoriesData['statistics-and-probability']),
      noOfVideosEn: enCategoriesData ? getNoOfVideosInGyms(enCategoriesData['statistics-and-probability']) : 0,
      noOfActivitiesEn: enCategoriesData ? getNoOfActivitiesInGyms(enCategoriesData['statistics-and-probability']) : 0,
      noOfWatchedVideos: 0,
      isUpcoming: getIsUpcoming(locale, enCategoriesData, CATEGORY_PATHS.statisticsAndProbability),
      key: CATEGORY_PATHS.statisticsAndProbability,
    },
    {
      title: '',
      titleTransKey: 'functions' as const,
      path: getPath(locale, categoriesData, enCategoriesData, CATEGORY_PATHS.functions),
      categoryThemeColor: CATEGORY_COLORS['functions'].bgClass,
      categoryFontColor: CATEGORY_COLORS['functions'].textClass,
      noOfSubjects: categoriesData['functions'].length,
      isPublished: categoriesData['functions'].length > 0,
      noOfCompletedSubjects: 0,
      noOfChestsInGyms: getNoOfChestsInGyms(categoriesData['functions']),
      noOfVideos: getNoOfVideosInGyms(categoriesData['functions']),
      noOfActivities: getNoOfActivitiesInGyms(categoriesData['functions']),
      noOfVideosEn: enCategoriesData ? getNoOfVideosInGyms(enCategoriesData['functions']) : 0,
      noOfActivitiesEn: enCategoriesData ? getNoOfActivitiesInGyms(enCategoriesData['functions']) : 0,
      noOfWatchedVideos: 0,
      isUpcoming: getIsUpcoming(locale, enCategoriesData, CATEGORY_PATHS.functions),
      key: CATEGORY_PATHS.functions,
    },
  ]

  return bootcampCategories
}

const getIsUpcoming = (
  locale: AppLanguage,
  enCategoriesData: CategoriesData | null,
  key: CategoryPathUrls,
): boolean => {
  return locale !== AppLanguage.EN && !!enCategoriesData && enCategoriesData?.[key]?.length > 0
}

const getPath = (
  locale: AppLanguage,
  categoriesData: CategoriesData | null,
  enCategoriesData: CategoriesData | null,
  category: CategoryPathUrls,
): string => {
  const isUpcoming = getIsUpcoming(locale, enCategoriesData, category)
  if (!categoriesData?.[category].length && isUpcoming) {
    return `/bootcamp/${category}/${enCategoriesData?.[category]?.[0]?.key}`
  }
  return `/bootcamp/${category}/${categoriesData?.[category]?.[0]?.key}`
}

const getNoOfChestsInGyms = (
  pageData: Array<{
    chests: Array<{ moduleNumber: string; pages?: Array<{ activities?: Array<{ difficulties?: number[] }> }> }>
    key: string
  }>,
): Array<{ key: string; totalChests: number }> => {
  return pageData.map(({ chests, key }) => {
    const totalChests = chests?.reduce<number>((a, b) => {
      const pages =
        b?.pages?.reduce<number>((c, d) => {
          const activities =
            d?.activities?.reduce<number>((e, f) => {
              const difficulties =
                f?.difficulties?.reduce<number>((g, h) => {
                  return g + (h ?? 0)
                }, 0) ?? 0
              return e + difficulties
            }, 0) ?? 0
          return c + activities
        }, 0) ?? 0
      return a + pages
    }, 0)

    return {
      key,
      totalChests,
    }
  })
}
const getNoOfVideosInGyms = (
  data: Array<{
    _id: string
    chests: []
    noOfVideo: number
    key: string
  }>,
): number => {
  return data.reduce<number>((prev, curr) => prev + curr.noOfVideo, 0)
}
const getNoOfActivitiesInGyms = (
  data: Array<{
    _id: string
    chests: []
    noOfActivities: number
    key: string
  }>,
): number => {
  return data.reduce<number>((prev, curr) => prev + curr.noOfActivities, 0)
}

export default getTopicList
